"use client";
import { useEffect, useState, useRef } from "react";

import Link from "next/link";
import Image from "next/image";
import { usePathname } from "next/navigation";

import { useTranslations } from "next-intl";

import { Loader } from "../Loader";
import ReactPaginate from "react-paginate";

import { getSiteInfo, typeCheck } from "@/utils";
import { useGetBlogListQuery } from "@/store";

export const BlogListWithTags = ({ showPagination = true, filterTags }) => {
  const [page, setPage] = useState(1);
  const filteredBlogRef = useRef(null);
  const { type, lang } = getSiteInfo();
  const t = useTranslations();
  
  const { data: blogData, isLoading } = useGetBlogListQuery({ page, tags: filterTags });
  
  
  const { meta } = blogData?.body ?? {};
  const totalPages = meta?.last_page;
  
  const handlePageClick = (event) => {
    let selected = event.selected;
    setPage(selected + 1);
    
    if (filteredBlogRef.current) {
      filteredBlogRef.current.scrollIntoView({
        behavior: "smooth",
      });
    }
  };


  let filteredBlogs = blogData?.body?.data
  
  const dynamicSlug = typeCheck(type, [`/bloq`, `/blog`]);
  return (
    <>
      {isLoading ? (
          <Loader />
        ) : (

        <div className={`relative mt-12  ${ filteredBlogs?.length >= 1 ? 'block' : 'hidden'}  `}  id="filteredBlog" ref={filteredBlogRef}>
          {filteredBlogs?.length >= 1 && 
              <h1 className="sm:text-[22px] sm:leading-[44px] tracking-[0.1px] sm:text-center md:text-[32px] font-medium text-[#300B60] leading-[38px] p-0 mb-8">
                {t("blog")}
              </h1>
            }
          <div className="mt-24 mb-24 md:p-4 p-2 mx-auto max-w-[1296px] h-full grid md:grid-cols-1 lmd:grid-cols-2 xl:grid-cols-3 gap-6">
            {!!filteredBlogs &&
              filteredBlogs?.map(({ id, image, created_at, title, tags, slug }) => (

                <Link
                  key={id}
                  prefetch={true}
                  replace={true}
                  href={`${dynamicSlug}/${slug}`}
                  className="blog-post bg-mainBgPurple relative py-2 md:min-w-[414px] px-2  rounded-[7px] transform hover:shadow-lg hover:border-mainLightPurpleActive transition duration-200 ease-in border-[2px] border-solid border-mainLightPurple cursor-pointer"
                >
                  <div>
                    {image ? (
                      <Image
                        className="w-full h-full  object-contain aspect-[16/9]   rounded-[7px] border border-solid border-slate-200"
                        src={`${process.env.API_URL}/storage/${image}`}
                        width={1296}
                        height={256}
                        alt={title}
                      />
                    ) : (
                      ""
                    )}
                  </div>
                  <h2 className="text-xl font-medium mt-[30px] mb-[24px] text-slate-700 min-h-[56px] line-clamp-2">
                    {title}
                  </h2>
                  <div className="flex flex-wrap gap-[8px] text-base min-h-[34px] self-end mb-2">
                    <span className="text-white border rounded-[8px] leading-[24px] bg-auto flex justify-center items-center bg-mainLightPurple px-4 h-[32px]">
                        {created_at}
                    </span>
                  </div>
                  <div className="flex flex-wrap gap-[8px] text-base min-h-[34px] self-end">
                    
                    {tags?.map((item, index) => (
                      item && <span
                        key={index}
                        className="text-white border rounded-[8px] leading-[24px] bg-auto flex justify-center items-center bg-mainLightPurple px-4 h-[32px]"
                      >
                        #{item.name}
                      </span>
                    ))}
                  </div>
                </Link>
              )
              )}
          </div>
          {showPagination && totalPages > 1 ? (
            <div className="mt-[4rem] mb-[3rem] flex items-center justify-center">
              <ReactPaginate
                breakLabel="..."
                className="flex"
                breakClassName="text-black p-2 self-end"
                pageLinkClassName="w-full h-full grid place-items-center rounded-lg"
                activeLinkClassName="text-black bg-mainLightPurple hover:bg-mainLightPurpleHover active:bg-mainLightPurpleActive text-white rounded-lg"
                pageClassName="border border-grey-200 w-10 h-10 rounded-lg text-slate-400 grid bg-white place-items-center m-1 hover:bg-mainLightPurpleHover hover:text-white active:bg-mainLightPurpleActive transition"
                nextLabel=">"
                nextClassName="border border-grey-200 w-10 h-10 rounded-lg text-slate-400 grid bg-white hover:bg-mainLightPurpleHover hover:text-white active:bg-mainLightPurpleActive place-items-center m-1"
                onPageChange={handlePageClick}
                pageCount={totalPages}
                pageRangeDisplayed={4}
                previousLabel="<"
                renderOnZeroPageCount={null}
                previousClassName="border border-grey-200 w-10 h-10 rounded-lg text-slate-400 grid bg-white hover:bg-mainLightPurpleHover hover:text-white active:bg-mainLightPurpleActive place-items-center m-1"
                previousLinkClassName="w-full h-full grid place-items-center"
                nextLinkClassName="w-full h-full grid place-items-center"
              />
            </div>
          ) : null}

          {filteredBlogs?.length >= 1 && 
            <div className="mx-auto w-1/2 xmd:w-1/4 mb-20 text-center -mt-10">
              <Link href={typeCheck(type, [`/bloq`, `/blog`])}>
                <button
                  type="button"
                  className="pt-[.56rem] pb-[.56rem] text-white bg-mainLightPurple hover:bg-mainLightPurpleHover active:bg-mainLightPurpleActive text-center rounded-[8px] btnLspace w-full font-semibold opacity-100"
                >
                  {t("blog_all")} 
                </button>
              </Link>
            </div>
          }
          
        </div>
      )}
    </>
  );
};
